import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsMileageDetails from "./contracts-mileage-details";
import ContractsMileageDetailsParamsParams from "./contracts-mileage-details-params";

const useContractsMileageDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsMileageDetails | null>(null);

  const load = async (
    params: ContractsMileageDetailsParamsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const mileageContractDetails =
        await contractsService.getMileageContractDetails(params, signal);

      setData(mileageContractDetails);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useContractsMileageDetails;
